import React from 'react';
import CheckoutList from './CheckoutList';
import CheckinList from './CheckinList';
import RolloverConfirm from './RolloverConfirm';
import styles from './StepPanel.module.css';

const StepPanel = ({
  step,
  stepInfo,
  stepData,
  isCompleting,
  onComplete,
  onRefresh,
}) => {
  if (!step || !stepInfo) {
    return (
      <div className={styles.empty}>
        <p>No active step</p>
      </div>
    );
  }

  const renderContent = () => {
    switch (step) {
      case 'CHECKOUT':
        return <CheckoutList data={stepData} onRefresh={onRefresh} />;
      case 'CHECKIN':
        return <CheckinList data={stepData} onRefresh={onRefresh} />;
      case 'ROLLOVER':
        return <RolloverConfirm stepData={stepData} />;
      default:
        return (
          <div className={styles.unknownStep}>
            <p>Step: {step}</p>
            <p>Ready to complete this step.</p>
          </div>
        );
    }
  };

  const canComplete = () => {
    if (step === 'CHECKOUT') return stepData?.pendingCheckouts === 0;
    if (step === 'CHECKIN') return stepData?.pendingCheckins === 0;
    if (step === 'ROLLOVER') return stepData?.canRollover !== false;
    return true;
  };

  const getPendingMessage = () => {
    if (step === 'CHECKOUT' && stepData?.pendingCheckouts > 0) {
      return `Please complete ${stepData.pendingCheckouts} pending checkout(s) first`;
    }
    if (step === 'CHECKIN' && stepData?.pendingCheckins > 0) {
      return `Please complete ${stepData.pendingCheckins} pending check-in(s) first`;
    }
    if (step === 'ROLLOVER' && stepData?.canRollover === false) {
      const verification = stepData?.verification;
      if (verification) {
        const pending = [];
        if (verification.pendingCheckouts > 0) pending.push(`${verification.pendingCheckouts} checkout(s)`);
        if (verification.pendingCheckins > 0) pending.push(`${verification.pendingCheckins} check-in(s)`);
        return `Cannot rollover: ${pending.join(' and ')} pending`;
      }
      return 'Cannot complete rollover at this time';
    }
    return '';
  };

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <div>
          <h2>{stepInfo.name}</h2>
          <p>{stepInfo.description}</p>
        </div>
        <button className={styles.refresh} onClick={onRefresh}>
          Refresh
        </button>
      </div>

      <div className={styles.content}>{renderContent()}</div>

      <div className={styles.actions}>
        <button
          className={styles.complete}
          onClick={onComplete}
          disabled={!canComplete() || isCompleting}
        >
          {isCompleting ? 'Completing...' : 'Complete Step'}
        </button>

        {!canComplete() && (
          <p className={styles.warning}>
            {getPendingMessage()}
          </p>
        )}
      </div>
    </div>
  );
};

export default StepPanel;
